import { PageShell } from "./PageShell";
import { HowItWorks } from "./HowItWorks";
import { FinalCTA } from "./FinalCTA";

export default function HowPage() {
  return (
    <PageShell testId="how-page">
      <div className="pt-[72px]">
        <HowItWorks />
      </div>
      <FinalCTA />
    </PageShell>
  );
}
